import { useEffect, useRef, useState } from "react";
import { NOTE_MAX_LENGTH } from "./cargo.model";
import { ShipmentDrawer } from "./ShipmentDrawer";

type ContainerNoteDrawerProps = {
  /** "MSCU7742051 · 40' High Cube" — which container the note is on. */
  sub: string;
  note: string;
  /** Writes the note into the Cargo tab's form; the header's Save sends it with the grid. */
  onSave: (note: string) => void;
  onClose: () => void;
};

/**
 * `#shdoc` holding one container's note: the design's `openContainerNotes`.
 * The note is a field of the container (`containers.*.note`), so "Save note"
 * keeps it with the grid's other edits rather than calling the API itself.
 */
export const ContainerNoteDrawer = ({ sub, note, onSave, onClose }: ContainerNoteDrawerProps) => {
  const [value, setValue] = useState(note);
  const [saved, setSaved] = useState(false);
  const timer = useRef<number>();

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const save = () => {
    onSave(value);
    setSaved(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setSaved(false), 1600);
  };

  return (
    <ShipmentDrawer kind="notes" title="Notes" sub={sub} onClose={onClose}>
      <div className="shnote">
        <label className="shnote__f">
          <span>Your note</span>
          <textarea
            className="shnote__in"
            rows={8}
            maxLength={NOTE_MAX_LENGTH}
            value={value}
            placeholder="Add anything the team should know about this container"
            onChange={(event) => {
              setValue(event.target.value);
              setSaved(false);
            }}
          />
          <em className="shnote__cnt">
            {value.length} / {NOTE_MAX_LENGTH}
          </em>
        </label>
        <button type="button" className="pcbtn pcbtn--main shnote__save" disabled={value === note} onClick={save}>
          {saved ? "Saved" : "Save note"}
        </button>
      </div>
    </ShipmentDrawer>
  );
};
